export const getSearchProcessedData = (data) => {
  const searchBillData = data?.payeesSearch?.map?.((item, index) => ({
    id: index + 1,
    value: item && item.payeeName,
    billerZipRequired: item && item.isPayeeZipRequired
  }))
  return searchBillData
}

export const serachPayloadData = (isRestAPI, val) => {
  let payloadData = {}
  if (isRestAPI) {
    payloadData = {
      payload: {
        searchParameters: [
          {
            payeeName: val
          }
        ]
      }
    }
  } else {
    payloadData = {
      appName: 'BILLPAY',
      payeeListInquiryRequest: {
        name: val
      }
    }
  }

  return payloadData
}
